import * as React from 'react';
import { Row as AntdRow, Col } from 'antd';


export interface IHorizontalElementsProps {
    fistElementSpan: number;
    offsets: number[];
    firstElement: JSX.Element;
    secondElement: JSX.Element;
}

export const HorizontalTwoElements = ( props: IHorizontalElementsProps) => {
    return (
        <AntdRow>
            <Col span={props.fistElementSpan} offset={props.offsets[0]} >
                {props.firstElement}
            </Col>
            <Col span={24-props.fistElementSpan} offset={props.offsets[1]} >
                {props.secondElement}
            </Col>
        </AntdRow>
    );
};